import { toggle } from "../utils";
document.addEventListener('DOMContentLoaded', function () {
    toggle({
        handler: ".abi-header__navigation-button",
        container: ".abi-header__navigation",
        toggleClass: "active",
    });
    var headerLinks = document.querySelectorAll(".abi-header__navigation-item-link");
    if (headerLinks) {
        headerLinks.forEach(function (link) {
            link.addEventListener('click', function (event) {
                var _a, _b;
                (_a = document.querySelector(".abi-header__navigation")) === null || _a === void 0 ? void 0 : _a.classList.remove('active');
                (_b = document.querySelector(".abi-header__navigation-button")) === null || _b === void 0 ? void 0 : _b.classList.remove('active');
            });
        });
    }
});
